module.exports = __webpack_public_path__ + "static/media/KC.ff456a80.svg";